import { useNavigate } from 'react-router'
import { ErrorApi } from '../../models/error.api.type'

type TProps = {
  mensaje: string
  isError: boolean
  mensajeError: string
  errorApi: any
}

/**
 * Componente generico de carga/error: muestra spinner mientras carga o detalle del error
 * con boton de reintento. Se usa en listados y pantallas que consumen queries RTK.
 */
export const CargaInfo = ({ mensaje, isError, mensajeError, errorApi }: TProps) => {
  const history = useNavigate()

  return (
    <>
      <div className='row'>
        <div
          className='col-12 d-flex align-items-center justify-content-center'
          style={{ height: '650px' }}>
          {!isError ? (
            <div className='d-flex align-items-center flex-column'>
              <div className='sk-chase'>
                <div className='sk-chase-dot'></div>
                <div className='sk-chase-dot'></div>
                <div className='sk-chase-dot'></div>
                <div className='sk-chase-dot'></div>
                <div className='sk-chase-dot'></div>
                <div className='sk-chase-dot'></div>
              </div>
              <h3 className='fw-lighter my-10'>{mensaje}</h3>
            </div>
          ) : (
            <div className='d-flex align-items-center flex-column'>
              <i className='fas fa-exclamation-triangle fs-5x mb-5'></i>
              <h2 className='fw-lighter mt-5'>{mensajeError}</h2>
              {
                errorApi?.data?.code && errorApi?.data?.moreInfo && (
                  <h5 className='fw-lighter mt-5 '>{`(${errorApi?.data?.code}) ${errorApi?.data?.moreInfo}`}</h5>
                )
              }
              <div className='d-flex mt-10'>
                <button className='btn btn-bg-light btn-active-color-primary' onClick={() => history(0)}>
                  Intentar de nuevo
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}
